<th class="pricing-expanded-collapse"></th>
<th
   *ngIf="siteCount > 2 && !isRequestView()"
   mat-sort-header="siteName"
   class="pricing-site">
   Site
</th>
<th
   *ngIf="displayAsReview()"
   mat-sort-header="requestedOn"
   class="pricing-prices">
   Requested
   <br />
   Date
</th>
<th
   *ngIf="showPracticeColumn() && isRequestView()"
   mat-sort-header="practiceName"
   class="pricing-recordName">
   Practice
   <br />
   Name
</th>
<th
   mat-sort-header="code"
   class="pricing-code">
   Product
   <br />
   Code
</th>
<th
   mat-sort-header="recordName"
   [ngClass]="displayAsReview() ? 'pricing-recordName' : 'pricing-recordName-practice'">
   Product
   <br />
   Name
</th>
<th
   *ngIf="!displayAsReview()"
   mat-sort-header="pimsCategory"
   class="pricing-pimsCategory">
   PIMS
   <br />
   Category
</th>
<th
   mat-sort-header="l12MRevenue"
   class="pricing-prices"
   style="white-space: nowrap !important">
   L12M
   <br />
   Rev. $
</th>
<th
   mat-sort-header="pctAnnualRevenue"
   class="pricing-pct"
   *ngIf="!isRequestView() && !displayAsReview()"
   style="white-space: nowrap !important">
   L12M
   <br />
   Rev. %
</th>
<th
   mat-sort-header="l12MTransactionPct"
   *ngIf="!isRequestView() && !displayAsReview()"
   class="pricing-pct"
   style="white-space: nowrap !important">
   % Trans.
   <br />
   L12M
</th>
<th
   mat-sort-header="distinctClientCount"
   class="pricing-distinctClientCount">
   L12M
   <br />
   Client
   <br />
   Count
</th>
<th
   mat-sort-header="quantityBreak"
   class="pricing-quantityBreak">
   Qty
   <br />
   Break
</th>
<th
   mat-sort-header="currentPrice"
   class="pricing-prices">
   Current
   <br />
   Price
</th>
<!--<th
   *ngIf="activeCycle()"
   mat-sort-header="modelPrice"
   class="pricing-prices">
   Model
   <br />
   Price
</th>-->
<th
   mat-sort-header="newPrice"
   class="pricing-inputPrice">
   Practice
   <br />
   Requested
   <br />
   Price
</th>
<th
   *ngIf="displayAsReview()"
   mat-sort-header="opsPrice"
   class="pricing-inputPrice">
   Ops
   <br />
   Override
   <br />
   Price
</th>
<th class="pricing-prices">
   Total
   <br />
   Current
   <br />
   Fees
</th>
<th class="pricing-prices">
   Total
   <br />
   Current
   <br />
   Price
</th>

<th
   mat-sort-header="totalRequestedPrice"
   class="pricing-inputPrice"
   [ngStyle]="{
      color: displayAsReview() ? '#212529' : '#339594'
   }">
   Total
   <br />
   Requested
   <br />
   Price
</th>

<!-- isCaptain means it's the admin page, not the hospital page -->
<th
   *ngIf="displayAsReview()"
   mat-sort-header="totalOpsPrice"
   class="pricing-inputPrice"
   [ngStyle]="{
      color: '#339594'
   }">
   Total
   <br />
   Ops
   <br />
   Price
</th>
<!--<th
   *ngIf="displayAsReview() && !isRequestView()"
   class="pricing-prices"
   mat-sort-header="modelImpact">
   Model
   <br />
   Price
   <br />
   Impact
</th>-->
<th
   *ngIf="displayAsReview()"
   class="pricing-prices"
   mat-sort-header="revenueImpact">
   Requested
   <br />
   Price
   <br />
   Impact
</th>
<th
   *ngIf="displayAsReview()"
   class="pricing-prices"
   mat-sort-header="finalPriceImpact">
   Final
   <br />
   Price
   <br />
   Impact
</th>
<th class="text-end pricing-action-buttons-header"></th>
